import React from 'react';
import './FeedHorizontalBlock.css';
import {RandomTime} from "../../../components/smiWidgets/RandomTime"
import { useVisibilityTracker } from "../../../utils/visibilityTracker"

const FeedHorizontalItem = ({ item, objectId, itemsLength, showId, campaignId, creativeId, bidderId, bidderCid, imptrackers, eventtrackers }) => {
    const visibilityRef = useVisibilityTracker(
        item.id,
        objectId,
        'FeedHorizontalBlock',
        itemsLength,
        showId,
        campaignId,
        creativeId,
        bidderId,
        bidderCid,
        imptrackers,
        eventtrackers
    );
    return (
        <a key={item.id} href={item.url} target="_blank" rel="noopener noreferrer" ref={visibilityRef}>
            <div className="feed-horizontal-block">
                <img src={item.img.replace('100_100', '200_200')} alt={item.title} />
                <div className="feed-horizontal-title">
                    <h2>{item.title}</h2>
                    <RandomTime />
                </div>
            </div>
        </a>
    );
};

export const FeedHorizontalBlock = ({ items, isDesktop, objectId, showId }) => {
    const filteredItems = !isDesktop ? items.slice(0, 4) : items;
    return (
        <div className="feed-horizontal-grid">
            {filteredItems.map(item => (
                <FeedHorizontalItem
                    key={item.id}
                    item={item}
                    objectId={objectId}
                    itemsLength={filteredItems.length}
                    showId={showId}
                    campaignId={item.cid}
                    creativeId={item.crid}
                    bidderId={item.bidder_id}
                    bidderCid={item.bidder_cid}
                    imptrackers={item.imptrackers}
                    eventtrackers={item.eventtrackers}
                />
            ))}
        </div>
    );
};
